function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m583.32 233.32h-466.65c-32.211 0-58.324-26.113-58.324-58.324s26.113-58.324 58.324-58.324h466.68c32.211 0 58.324 26.113 58.324 58.324s-26.141 58.324-58.352 58.324z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.82 408.32h-291.65c-32.211 0-58.324-26.113-58.324-58.324s26.113-58.324 58.324-58.324h291.68c32.211 0 58.324 26.113 58.324 58.324s-26.141 58.324-58.352 58.324z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.32 583.32h-116.65c-32.211 0-58.324-26.113-58.324-58.324s26.113-58.324 58.324-58.324h116.68c32.211 0 58.324 26.113 58.324 58.324s-26.141 58.324-58.352 58.324z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.44e6760cd5b6cbc858cfe8cb21d57025.svg";
export { ForwardRef as ReactComponent };